import { render, staticRenderFns } from "./ReplicantiUpgradeButton.vue?vue&type=template&id=2708e750&scoped=true"
import script from "./ReplicantiUpgradeButton.vue?vue&type=script&lang=js"
export * from "./ReplicantiUpgradeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2708e750",
  null
  
)

export default component.exports